import { call, put, takeLatest } from "redux-saga/effects";
import api from "service/apiService";
import {
	CreateAnnouncementPayload,
	DeleteAnnouncementPayload,
	GetDetailAnnouncementPayload,
	GetListAnnouncementPayload,
	UpdateAnnouncementPayload,
	createAnnouncementAsync,
	deleteAnnouncementAsync,
	getDetailAnnouncementAsync,
	getListAnnouncementAsync,
	setDetailAnnouncement,
	setListAnnouncement,
	updateAnnouncementAsync,
} from "./announcement.slice";
import { message } from "antd";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";

function* getListAnnouncementSaga(
	action: PayloadAction<GetListAnnouncementPayload>,
) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/dashboard/announcement", {
				...query,
				skip: query.skip * query.take,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setListAnnouncement.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetListAnnouncement() {
	yield takeLatest(getListAnnouncementAsync, getListAnnouncementSaga);
}

function* createAnnouncementSaga(
	action: PayloadAction<CreateAnnouncementPayload>,
) {
	const { data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/dashboard/announcement", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(translate("Create successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchCreateAnnouncement() {
	yield takeLatest(createAnnouncementAsync, createAnnouncementSaga);
}

function* updateAnnouncementSaga(
	action: PayloadAction<UpdateAnnouncementPayload>,
) {
	const { id, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(
				`/dashboard/announcement/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateAnnouncement() {
	yield takeLatest(updateAnnouncementAsync, updateAnnouncementSaga);
}

function* getDetailAnnouncementSaga(
	action: PayloadAction<GetDetailAnnouncementPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(`/dashboard/announcement/${id}`);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		yield put({ type: setDetailAnnouncement.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetDetailAnnouncement() {
	yield takeLatest(getDetailAnnouncementAsync, getDetailAnnouncementSaga);
}

function* deleteAnnouncementSaga(
	action: PayloadAction<DeleteAnnouncementPayload>,
) {
	const { id, query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.delete(
				`/dashboard/announcement/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: getListAnnouncementAsync.type, payload: { query, callback } });
		message.success(translate("Delete successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchDeleteAnnouncement() {
	yield takeLatest(deleteAnnouncementAsync, deleteAnnouncementSaga);
}

const announcementSaga = [
	watchGetListAnnouncement(),
	watchCreateAnnouncement(),
	watchUpdateAnnouncement(),
	watchGetDetailAnnouncement(),
	watchDeleteAnnouncement(),
];

export default announcementSaga;
